import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailTicketComponent, EmailType } from '../email-ticket/email-ticket.component';
import { Observable } from 'rxjs';
import { TicketTrackingEvent, TicketTrackingService } from '@app/layout/sites/tickets/ticket-tracking.service';
import { I18nMessage } from '@app/shared/api/model/i18n';
import { EmailTrackingCampaignName, EscalatedTicket, TicketEmail } from '@shared/services';


interface FormDetail {
  titleMessage: I18nMessage;
  buttonClass: string;
}

@Component({
  selector: 'app-email-ticket-modal',
  templateUrl: './email-ticket-modal.component.html',
  styleUrls: ['./email-ticket-modal.component.scss'],
  standalone: false
})
export class EmailTicketModalComponent implements OnInit, OnChanges {

  @Input() ticket: EscalatedTicket;
  @Input() send: any;
  @Input() beforeClose: () => Observable<any>;
  @Input() emailType: EmailType;
  @Input() campaignName: EmailTrackingCampaignName;

  @ViewChild(EmailTicketComponent, { static: false })
  emailComponent: EmailTicketComponent;
  sending = false;
  private formDetailMap: Map<EmailType, FormDetail> = new Map([
    [EmailType.APPROVE, {titleMessage: {messageKey: 'Approve Action'}, buttonClass: 'btn-success'}],
    [EmailType.FORWARD, {titleMessage: {messageKey: 'Forward E-Mail'}, buttonClass: 'btn-primary'}]
  ]);

  constructor(public activeModal: NgbActiveModal, private ticketTrackingService: TicketTrackingService) {}

  ngOnChanges(_changes: SimpleChanges): void {
    this.checkRequiredInputs();
  }

  ngOnInit(): void {
    this.checkRequiredInputs();
  }

  onSubmit() {
    this.sending = true;
    this.emailComponent.sendEmail();
    this.ticketTrackingService.trackTicket(TicketTrackingEvent.EMAILED, this.ticket, { type: EmailType[this.emailType] });
  }

  private closeModal(sent: TicketEmail) {
    this.sending = false;
    this.activeModal.close(sent);
  }

  onSent(sent: TicketEmail) {
    if (this.beforeClose != null) {
      this.beforeClose()
          .subscribe(() => {})
          .add(() => this.closeModal(sent));
    } else {
      this.closeModal(sent);
    }
  }

  get formDetail(): FormDetail {
    return this.formDetailMap.get(this.emailType);
  }

  private checkRequiredInputs(): void {
    if (this.campaignName == null) {
      throw new Error('CampaignName must be supplied');
    }
  }

}
